/* 布局 */
//前台
import Layout from "@views/layout";

const plaversionRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "plaversion/list",
        name: "PLAVERSION",
        meta: {
            title: "版本管理",
        },
        component: () => import("@views/business/plaversion/index.vue"),
    },
        ],
};

export default plaversionRouter;
